<!-- 冷库管理界面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <div class="section-main_table" style="flex-direction: column">
          <ioc-table ref="storageTab" :data="tableData" :option="tableOption" :page="page" @current-change="selectPage"
            @size-change="changeSize" @selection-change="handleSelectionChange">
            <!-- 上方按钮 -->
            <template slot="menuLeft">
              <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus"
                @click="handleAddStorage">
                新增
              </el-button>
              <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-delete"
                @click="handelDeleteStorages">
                批量删除
              </el-button>
            </template>
            <!-- 启用状态栏 -->
            <template slot="storageStatus" slot-scope="scope">
              <el-switch v-model="scope.row.storageStatus" active-color="#13ce66" inactive-color="#ff4949"
                :active-value="1" :inactive-value="2" @change="changeStorageStatus(scope.row)">
              </el-switch>
            </template>
            <!-- 操作栏 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="分配库管" placement="top" popper-class="tooltip-draw"
                style="font-size: 16px;">
                <el-button type="text" icon="el-icon-user" @click="handleFpKg(scope.row, scope.index)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="库温阈值设置" placement="top" popper-class="tooltip-draw"
                style="font-size: 16px;">
                <el-button type="text" icon="el-icon-odometer" @click="temperConfig(scope.row, scope.index)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw"
                style="font-size: 16px;">
                <el-button type="text" icon="el-icon-edit-outline"
                  @click="handleUpdateStorage(scope.row, scope.index)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw"
                style="font-size: 16px;">
                <el-button type="text" icon="el-icon-delete"
                  @click="handelDeleteSingleStorage(scope.row, scope.index)"></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>

    <!-- 人员选择弹框 -->
    <el-dialog title="分配库管" :append-to-body="true" :visible.sync="dialogPeople" width="50%" class="choose-container">
      <div style="height: 580px">
        <!-- <ioc-table ref="personTable" :data="personData" :option="personOption" :page="personPage"
          @size-change="personChangeSize" @current-change="currentChange" @search-change="searchList"
          @search-reset="personReset" @selection-change="handlePersonSelectionChange">
        </ioc-table> -->
        <ioc-table ref="personTable" :data="personData" :option="personOption" @search-change="searchList"
          @search-reset="personReset" @selection-change="handlePersonSelectionChange">
        </ioc-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelChoose">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </span>
    </el-dialog>

    <!-- 库温阈值设置 -->
    <el-dialog :title="warningTitle" :visible.sync="warningVisible" append-to-body :close-on-click-modal="warningModalClose"
      width="48%">
      <div style="height: 400px; overflow-y: auto;">
        <el-table :data="configInfos" style="width: 100%;">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="subStorageCode" label="库号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.subStorageCode" placeholder="请输入库号" clearable />
            </template>
          </el-table-column>
          <el-table-column prop="minTemperature" label="库温最小值(°C)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.minTemperature" placeholder="请输入库温最小值" clearable />
            </template>
          </el-table-column>
          <el-table-column prop="maxTemperature" label="库温最大值(°C)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.maxTemperature" placeholder="请输入库温最大值" clearable />
            </template>
          </el-table-column>
          <el-table-column prop="subStorageStatus" label="状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.subStorageStatus" active-color="#409EFF" inactive-color="#EAECF0"
                active-value="1" inactive-value="2" active-text="启用" inactive-text="停用">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-circle-plus-outline" style="font-size: 20px;"
                @click="handleConfigAddRow(scope.$index)" />
              <el-button v-if="scope.$index >= 1" type="text" icon="el-icon-remove-outline" style="font-size: 20px;"
                @click="handleConfigRemoveRow(scope.$index)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="configClose">取 消</el-button>
        <el-button type="primary" @click="configConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新增/修改 -->
    <appPanel :width="750" class="app-panel" :isExpand="showPanel" @cancel="handleClosePanel" :title="title">
      <!-- 内容区域 -->
      <div>
        <el-form style="height: 99%; position: absolute; width: 100%" :inline="true" :model="storageFromInfo"
          :rules="storageFromRule" ref="storageForm" label-width="96px" label-position="right" label-suffix=" :">
          <el-scrollbar style="height: 100%">
            <el-row>
              <el-col :span="12">
                <el-form-item label="编号" prop="storageCode">
                  <el-input v-model="storageFromInfo.storageCode" placeholder="请输入编号" clearable :disabled="isUpdate">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="名称" prop="storageName">
                  <el-input v-model="storageFromInfo.storageName" placeholder="请输入名称" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="库存容量" prop="inventoryCapacity">
                  <el-input v-model="storageFromInfo.inventoryCapacity" placeholder="请输入库存容量" clearable
                    style="width: 210px">
                    <template slot="append">吨</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="面积" prop="area">
                  <el-input v-model="storageFromInfo.area" placeholder="请输入面积" clearable style="width: 210px">
                    <template slot="append">㎡</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="高度" prop="height">
                  <el-input v-model="storageFromInfo.height" placeholder="请输入高度" clearable style="width: 210px">
                    <template slot="append">m</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="月台数" prop="platformQuantity">
                  <el-input v-model="storageFromInfo.platformQuantity" placeholder="请输入月台数" clearable
                    style="width: 210px">
                    <template slot="append">个</template>
                  </el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-scrollbar>
        </el-form>
      </div>
      <!-- 按钮区域 -->
      <div slot="footer" class="dialog-footer" style="margin-bottom: 18px;">
        <el-button @click="handleClosePanel" type="info" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSavePanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </div>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/manageTable";
import { personOption } from "../config/personTable";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      form: {},
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
      // 选择的storageId
      checkedStorageIds: [],
      personSearch: {
        pageNum: 1,
        total: 10,
        // accountType: "3",
        accountType: "",
      },
      // 库管人员
      checkPeopleInfo: [],
      dialogPeople: false,
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      personData: [],
      personOption: personOption(),
      // 新增或修改
      isUpdate: false,
      subLoading: false,
      title: "",
      showPanel: false,
      storageFromInfo: {
        storageId: undefined,
        storageCode: "", // 编号
        storageName: "", // 名称
        inventoryCapacity: "", // 容量
        area: "", // 面积
        height: "", // 高度
        // platformQuantity: "", // 月台数
      },
      storageFromRule: {
        storageCode: [
          {
            required: true,
            message: "请输入编号",
            trigger: ["blur", "change"],
          },
        ],
        storageName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"],
          },
        ],
        inventoryCapacity: [
          {
            required: true,
            message: "请输入库存容量",
            trigger: ["blur", "change"],
          },
        ],
        area: [
          {
            required: true,
            message: "请输入面积",
            trigger: ["blur", "change"],
          },
        ],
        height: [
          {
            required: true,
            message: "请输入高度",
            trigger: ["blur", "change"],
          },
        ],
        // platformQuantity: [
        //   {
        //     required: true,
        //     message: "请输入月台数",
        //     trigger: ["blur", "change"],
        //   },
        // ],
      },
      currentStorageId: '',
      currentStorageName: '',
      checkedManage: [],
      warningTitle: '库温阈值设置',
      warningVisible: false,
      warningModalClose: false,
      configInfos: [{
        subStorageCode: "",
        minTemperature: "",
        maxTemperature: "",
        subStorageStatus: "2"
      }]
    };
  },
  mounted() {
    this.getList();
    this.getPersonList();
  },
  beforeDestroy() { },
  methods: {
    // 库温阈值设置
    temperConfig(row) {
      this.currentStorageId = row.storageId
      this.currentStorageName = row.storageName
      let params = {
        storageId: this.currentStorageId
      }
      this.$fetch(api.storage.queryConfig, params).then((response) => {
        if (response.success) {
          if (response.returnObj.length > 0) {
            this.configInfos = response.returnObj
          } else {
            this.configInfos = [{
              subStorageCode: "",
              minTemperature: "",
              maxTemperature: "",
              subStorageStatus: "2"
            }]
          }
          this.warningTitle = this.currentStorageName + '库温阈值设置'
          this.warningVisible = true
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleConfigAddRow(index) {
      this.configInfos.splice(index + 1, 0, {
        subStorageCode: "",
        minTemperature: "",
        maxTemperature: "",
        subStorageStatus: "2"
      });
    },
    handleConfigRemoveRow(index) {
      this.configInfos.splice(index, 1);
    },
    configConfirm() {
      let params = {
        storageId: this.currentStorageId,
        subColdStorages: this.configInfos
      }
      this.$fetch(api.storage.addConfig, params).then((response) => {
        if (response.success) {
          this.$message.success(response.msgContent);
          this.warningVisible = false
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    configClose() {
      this.warningVisible = false
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 冷库管理列表数据
    getList() {
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
        // pageNum: 1,
        // pageSize: 1000
      }
      this.$fetch(api.storage.queryColdStorageList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
          this.$refs.storageTab.selectClear();
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 查询已分配库管
    getWareHouseList() {
      let params = {
        storageId: this.currentStorageId
      }
      this.$fetch(api.storage.queryColdStorageManager, params).then((response) => {
        if (response.success) {
          this.checkedManage = response.returnObj
          this.$refs.personTable.selectClear();
          if (this.checkedManage.length == 0) {
            this.$nextTick(() => {
              this.$refs.personTable.selectClear();
            })
          } else {
            let list = this.checkedManage.map(item => item.accountNumber)
            let selectedPerson = []
            let emptyPerson = []
            this.personData.forEach(d => {
              if (list.includes(d.accountNumber)) {
                selectedPerson.push(d)
              } else {
                emptyPerson.push(d)
              }
            })
            this.personData = []
            this.personData = selectedPerson.concat(emptyPerson)
            this.$nextTick(() => {
              let list = this.checkedManage.map(item => item.accountNumber)
              this.personData.forEach(d => {
                if (list.includes(d.accountNumber)) {
                  this.$refs.personTable.$refs.multipleTable.toggleRowSelection(d, true);
                }
              })
            })
          }
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 处理分配库管
    handleFpKg(row) {
      this.currentStorageId = row.storageId
      this.getWareHouseList()
      this.dialogPeople = true;
    },
    handleAddStorage() {
      this.isUpdate = false
      this.title = "新增冷库信息";
      this.showPanel = true;
    },
    handleUpdateStorage(row, index) {
      this.isUpdate = true
      this.title = "修改冷库信息";
      this.showPanel = true;
      this.storageFromInfo = row;
    },
    handelSaveStorage(row, index) {
      row.edit = false;
    },
    handelCancelStorage(row, index) {
      row.edit = false;
    },

    handleSelectionChange(items) {
      if (!items || !items.length) {
        this.checkedStorageIds = [];
      } else {
        this.checkedStorageIds = items.map((item) => {
          return item.storageId;
        });
      }
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    // 单个删除
    handelDeleteSingleStorage(row) {
      this.$confirm("您确定删除该冷库吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.storage.deleteColdStorage, [row.storageId]).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          }
        );
      });
    },
    handelDeleteStorages() {
      if (this.checkedStorageIds.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择需要删除的冷库",
        });
        return;
      }
      this.$confirm("您确定要删除选中的冷库吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.storage.deleteColdStorage, this.checkedStorageIds).then((response) => {
          if (!response.success) {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          } else {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          }
          this.getList();
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 改变库存状态
    changeStorageStatus(val) {
      if (val.storageStatus == 2) {
        // 开启状态
        this.$confirm("您确定关闭该冷库吗?", "关闭确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$fetch(api.storage.updateColdStorage, {
            storageId: val.storageId,
            storageStatus: 2,
            storageCode: val.storageCode
          }).then((response) => {
            if (response && response.success) {
              this.$message({
                message: "关闭成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          });
        }).catch(() => {
          this.getList();
        });
      } else {
        // 关闭状态
        this.$confirm("您确定开启该冷库吗?", "开启确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$fetch(api.storage.updateColdStorage, {
            storageId: val.storageId,
            storageStatus: 1,
            storageCode: val.storageCode
          }).then((response) => {
            if (response && response.success) {
              this.$message({
                message: "开启成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          });
        }).catch(() => {
          this.getList();
        });
      }
    },
    // 取消新增/修改
    handleClosePanel() {
      this.showPanel = false;
      this.handleRestForm();
      // 刷新列表数据
      this.getList();
    },
    // 保存新增/修改
    handleSavePanel() {
      this.$refs.storageForm.validate((valid) => {
        if (valid) {
          // 关闭弹窗
          // this.showPanel = false;
          // this.handleRestForm();
          // 刷新列表数据
          // this.getList();
          let params = { ...this.storageFromInfo };
          if (params.storageId) {
            // 修改
            this.$fetch(api.storage.updateColdStorage, params).then((res) => {
              if (res.msgCode == "0") {
                this.$message({
                  message: '修改成功',
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$message({
                  message: '修改失败',
                  type: "error",
                  duration: 2000,
                });
              }
              // 关闭弹窗
              this.showPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getList();
            });
          } else {
            // 新增
            this.$fetch(api.storage.addColdStorage, params).then((res) => {
              if (res.msgCode == "0") {
                this.$message({
                  message: '新增成功',
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$message({
                  message: '新增失败',
                  type: "error",
                  duration: 2000,
                });
              }
              // 关闭弹窗
              this.showPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getList();
            });
          }
        } else {
          return false;
        }
      });
    },
    // 重置表单操作
    handleRestForm() {
      this.storageFromInfo.storageId = undefined;
      this.storageFromInfo.storageCode = ""; // 编号
      this.storageFromInfo.storageName = ""; // 名称
      this.storageFromInfo.inventoryCapacity = ""; // 容量
      this.storageFromInfo.area = ""; // 面积
      this.storageFromInfo.height = ""; // 高度
      // this.storageFromInfo.platformQuantity = ""; // 月台数
      this.$refs["storageForm"].clearValidate();
    },
    // 获取参与人员信息
    getPersonList() {
      const params = {};
      // params.pageNo = this.personPage.pageNum;
      // params.pageSize = this.personPage.pageSize;
      params.pageNo = 1;
      params.pageSize = 10000;
      params.accountType = this.personSearch.accountType;
      params.containOwnFlag = '1';
      this.$fetch(api.storage.queryPersonnelList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }

        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    personChangeSize(val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPersonList();
    },
    currentChange(val) {
      this.personPage.pageNum = val;
      this.getPersonList();
    },
    searchList(param) {
      this.personSearch = Object.assign(param);
      this.personPage.pageNum = 1;
      this.getPersonList();
    },
    personReset() {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = 10;
      this.personSearch.accountType = "3";
      this.getPersonList();
    },
    handlePersonSelectionChange(items) {
      if (!items || !items.length) {
        this.checkPeopleInfo = [];
      } else {
        this.checkPeopleInfo = items.map((item) => {
          let newItem = {
            label: item.nickName,
            value: item.accountNumber,
          };
          return newItem;
        });
      }
    },
    // 人员取消
    cancelChoose() {
      this.dialogPeople = false;
      this.checkPeopleInfo = [];
      this.$refs.personTable.selectClear();
    },
    // 人员确定
    confirmChoose() {
      if (this.checkPeopleInfo.length == 0) {
        this.$message.warning("请选择库管人员");
        return;
      }
      // if (this.checkPeopleInfo.length > 2) {
      //   this.$message.warning("最多只能选择两位库管人员");
      //   return;
      // }
      const managePeople = []
      for (let i = 0; i < this.checkPeopleInfo.length; i++) {
        managePeople.push(this.checkPeopleInfo[i].value)
      }
      let params = {
        id: this.currentStorageId,
        list: managePeople
      }
      this.$fetch(api.storage.addColdStorageAccount, params).then((res) => {
        if (res.msgCode == "0") {
          this.$message({
            message: '操作成功',
            type: "success",
            duration: 2000,
          });
        } else {
          this.$message({
            message: '操作失败',
            type: "error",
            duration: 2000,
          });
        }
      });
      this.cancelChoose();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.expand {
  width: calc(100% - 250px);
  height: auto;
}

.up {
  width: calc(100% - 250px);
  height: 41px;
  overflow: hidden;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;
  margin-top: -16px;

  .query {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;

    .el-form-item {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 8px !important;
      vertical-align: top;
    }
  }

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>
